import React, { useEffect, useMemo, useState } from "react";
import {
  XQUANT_FALLBACK_LOGO_URL,
  resolveLogoUrlForSymbol,
  extractUnderlyingSymbol,
} from "../../services/symbolBranding";
import styles from "./SymbolLogo.module.css";

interface SymbolLogoProps {
  symbol: string | null | undefined;
  logoUrl?: string | null;
  size?: number;
  className?: string;
}

export const SymbolLogo: React.FC<SymbolLogoProps> = ({
  symbol,
  logoUrl,
  size = 16,
  className = "",
}) => {
  const initialSource = useMemo(
    () => resolveLogoUrlForSymbol(symbol, logoUrl),
    [logoUrl, symbol],
  );

  const [currentSource, setCurrentSource] = useState(initialSource);
  const [fallbackFailed, setFallbackFailed] = useState(false);

  useEffect(() => {
    setCurrentSource(initialSource);
    setFallbackFailed(false);
  }, [initialSource]);

  const handleError = () => {
    if (currentSource !== XQUANT_FALLBACK_LOGO_URL) {
      setCurrentSource(XQUANT_FALLBACK_LOGO_URL);
      return;
    }
    setFallbackFailed(true);
  };

  if (fallbackFailed) {
    const label = extractUnderlyingSymbol(symbol).slice(0, 1) || "Q";
    return (
      <span
        aria-hidden="true"
        className={`${styles.symbolLogo} ${styles.symbolLogoTextFallback} ${className}`.trim()}
        style={{ ["--symbol-logo-size" as string]: `${size}px` }}
      >
        {label}
      </span>
    );
  }

  return (
    <img
      src={currentSource}
      onError={handleError}
      alt=""
      aria-hidden="true"
      className={`${styles.symbolLogo} ${className}`.trim()}
      style={{ ["--symbol-logo-size" as string]: `${size}px` }}
      loading="lazy"
      decoding="async"
      referrerPolicy="no-referrer"
    />
  );
};

